import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { inventory } from './inventory.schema';
import { locations } from './locations.schema';

export const inventory_location = sqliteTable('inventory_location', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  location_id: integer('location_id'),
  inventory_id: integer('inventory_id'),
  location_uuid: text('location_uuid').references(() => locations.id),
  inventory_uuid: text('inventory_uuid').references(() => inventory.id),
  user_id: integer('user_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
